import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, Row, Col, Form } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Modal from "react-bootstrap/Modal";
import "./ModalForm.scss";

const ModalForm = ({ show, handleClose}) => {

  const location = useLocation();

  const navigate = useNavigate();

  // const [adParams, setAdParams] = useState({});
  const [fullUrlWithParams, setFullUrlWithParams] = useState('');

  const [formData, setFormData] = useState({
    email: "",
    name: "",
    mobileNo: "",
    contCode: "+91",
    company: "",
    noEmployee: "",
    myText: "",
  });

  // Validation state
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  // Validation function
  const validateForm = useCallback(() => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Email format is invalid";
    }

    // Name
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
      newErrors.name = "Name must only contain alphabets";
    }

    // Mobile Number
    if (formData.contCode !== "IN" && formData.contCode !== "+91") {
      if (!formData.mobileNo.trim()) {
        newErrors.mobileNo = "Mobile No. is required";
      }
    } else {
      if (!formData.mobileNo.trim()) {
        newErrors.mobileNo = "Mobile No. is required";
      } else if (!/^[6-9]\d{9}$/.test(formData.mobileNo)) {
        newErrors.mobileNo =
          "Enter a valid 10-digit mobile number starting with 6-9";
      }
    }

      // Company
      if (!formData.company.trim()) {
        newErrors.company = "Company Name is required";
      } else if (!/^[a-zA-Z0-9\s,&.-]+$/.test(formData.company)) {
        newErrors.company =
          "Company Name can only contain letters, numbers, and basic punctuation (, & . -)";
      }

      if (!formData.noEmployee || formData.noEmployee.trim() === "") {
        newErrors.noEmployee = "Number of Employees is required";
      }

    // Message
    // if (formData.myText.length > 500) {
    //   newErrors.myText = "Message cannot exceed 500 characters";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [formData]);

  // Input change handler
  const handleInputChange = useCallback((e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
      setTouched((prev) => ({ ...prev, [name]: true }));
    }
  }, []);

  const handlePhoneChange = useCallback((value) => {
    setFormData((prev) => ({ ...prev, contCode: value }));
    setTouched((prev) => ({ ...prev, contCode: true }));
  }, []);

  // Blur handler to mark fields as touched
  const handleBlur = useCallback((e) => {
    if (e && e.target) {
      const { name } = e.target;
      setTouched((prev) => ({ ...prev, [name]: true }));
    }
  }, []);
      
    // Reset function
  const resetForm = useCallback(() => {
    setFormData({
      email: "",
      name: "",
      mobileNo: "",
      contCode: "+91",
      company: "",
      noEmployee: "",
      myText: "",
    });
    setTouched({});
    setErrors({});
  }, []);

  // Run validation when form data changes
  useEffect(() => {
    validateForm();
  }, [formData, validateForm]);

  // Close handler that resets the form
  const handleModalClose = useCallback(() => {
    resetForm();
    handleClose();
  }, [resetForm, handleClose]);
  
  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const allTouched = {};
    Object.keys(formData).forEach((key) => {
      allTouched[key] = true;
    });
    setTouched(allTouched);

    // Run validation before submission
    const isValid = validateForm();
    if (!isValid) {
      return;
    }

    const body = `
              <table border="1" cellpadding="5" cellspacing="0" width="650" style="word-break:break-word; width:650px; border-width:2px; border-color:antiquewhite;font-size: 14px;">
                <tr><td><span style="font-weight:700; padding-right:10px;">Name:</span>${formData.name}</td><td><span style="font-weight:700; padding-right:10px;">Email: </span>${formData.email}</td></tr>
                <tr><td colspan="2"><span style="font-weight:700; padding-right:10px;">Mobile Number:</span> ${formData.contCode} ${formData.mobileNo}</td></tr>
                <tr><td><span style="font-weight:700; padding-right:10px;">Company Name:</span>${formData.company}</td><td><span style="font-weight:700; padding-right:10px;">Number of Employee:</span>${formData.noEmployee}</td></tr>
                <tr><td colspan="2"><span style="font-weight:700; padding-right:10px;">Message:</span>${formData.myText}</td></tr>
                <tr><td colspan="2"><span style="font-weight:700; padding-right:10px;"> Landing Page Url: </span>${fullUrlWithParams}</td></tr>
              </table>
            `;

    const mailOptionsAdmin = {
      // SendTo: "ramesh@intecinfonet.com",
      // SendCc: "ramesh@intecinfonet.com",

      SendTo:'sales@qkrbiz.com',
      SendCc:'rajeev_goel@intecinfonet.com, prashant@intecinfonet.com,vaishali@intecinfonet.com, gaurav@intecinfonet.com, ramesh@intecinfonet.com',

      MailSubj: `Enquiry received from ${formData.name}`,
      Message: body,
    };

    const thankYouBody = `
              <p>Dear ${formData.name},</p>
              <p style='margin:0px; color: #212832;'>Thank you for reaching out to QkrHR!</p>
              <p style='margin:0px;color: #212832;'>We're thrilled that you're taking the first step towards revolutionizing your HR operations.</p>
              <h5 style="font-size:13px; color: #212832;margin-bottom: 0px;margin-top: 10px;">Our Team Will Connect with You Within 24 Hours To:</h5>
              <ul style='padding-left: 10px;'>
                  <li style="color: #212832;">Dive Deep into Your Unique HR Challenges</li>
                  <li style="color: #212832;">Schedule a personalized demo</li>
                  <li style="color: #212832;">Explore how QkrHR can streamline your HR processes</li>
              </ul>
              <div style="display: inline-block;width: 100%;"> 
                <p style='margin:0px;color: #212832;'>Get Ready to Reimagine HR!</p>
                <p style='margin:0px;color: #212832;'>Best Regards</p>
                <p style='margin:0px;color: #212832;'> QkrHR Team</p>
                <p style="color: #212832;">Qkrbiz | Intec Infonet Pvt. Ltd.</p>
              </div>
              <div style="display: inline-block;width: 100%;">    
                <a href='https://www.facebook.com/Qkrbiz/' style="float: left;margin-right:7px;">
                    <img src="https://www.qkrbiz.com/assets/images/facebook-icon.png" alt="Facebook" style="width: 30px;height: 30px"/>
                </a>
                <a href='https://www.instagram.com/qkrbiz/' style="float: left;margin-right:7px;">
                    <img src="https://www.qkrbiz.com/assets/images/instragam-icon.png" alt="Instagram" style="width: 30px;height: 30px" />
                </a>
                <a href='https://www.youtube.com/@Qkrbiz/' style="float: left;margin-right:7px;">
                    <img src="https://www.qkrbiz.com/assets/images/youtube-icon.png" alt="YouTube" style="width: 30px;height: 30px" />
                </a>
                <a href='https://www.linkedin.com/company/qkrbiz/' style="float: left;margin-right:7px;">
                    <img src="https://www.qkrbiz.com/assets/images/linkedin-icon.png" alt="Linkedin" style="width: 30px;height: 30px" />
                </a>
                <a href='https://x.com/QkrBiz' style="float: left;margin-right:7px;">
                    <img src="https://www.qkrbiz.com/assets/images/twitter-icon.png" alt="Twitter" style="width: 30px;height: 30px" />
                </a>
              </div>
            `;

    const mailOptionsUser = {
      SendTo: formData.email,
      MailSubj: `Thanks for Signing Up for QkrHR, Let's Get Started!`,
      Message: thankYouBody,
    };

    try {
      // Send email to Admin
      await axios.post(
        "https://intec.qkrbiz.com/api/mail/sendemail",
        mailOptionsAdmin,
        { headers: { "Content-Type": "application/json" } }
      );

      // Send thank-you email to the user
      await axios.post(
        "https://intec.qkrbiz.com/api/mail/sendemail",
        mailOptionsUser,
        { headers: { "Content-Type": "application/json" } }
      );

      navigate("/thank-you");
      resetForm();
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  // Then in your useEffect:
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    
    // Capture Google Ads parameters
    ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
      if (searchParams.has(param)) {
        params[param] = searchParams.get(param);
      }
    });
    
    // console.log('Captured Ad Params:', params);
    // console.log('Full URL with Params:', window.location.href);

    // setAdParams(params);
    setFullUrlWithParams(window.location.href);
    
    // Store these parameters in localStorage for cross-page tracking
    localStorage.setItem('adParams', JSON.stringify(params));
  }, [location]);

  return (
    <>
      <Modal size="lg" show={show} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title className="mb-1">
          <span className="text-pink">Smart HR </span> for Smarter Decisions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="mt-1">
              <Col lg={6}>
                <div className="mb-3">
                  <label htmlFor="Name" className="input-material">
                    <input
                      type="text"
                      name="name"
                      className={`form-control form-control-lg ${
                        errors.name && touched.name
                          ? "is-invalid"
                          : touched.name
                          ? "is-valid"
                          : ""
                      }`}
                      value={formData.name}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder=""
                    />
                    <span className="label-material">
                      Name<span className="text-danger">*</span>
                    </span>
                    {/* {errors.name && touched.name && <div className="invalid-feedback">{errors.name}</div>} */}
                  </label>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label htmlFor="Work Email" className="input-material">
                    <input
                      type="text"
                      name="email"
                      className={`form-control form-control-lg ${
                        errors.email && touched.email
                          ? "is-invalid"
                          : touched.email
                          ? "is-valid"
                          : ""
                      }`}
                      value={formData.email}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder=""
                    />
                    <span className="label-material">
                      Work Email<span className="text-danger">*</span>
                    </span>
                    {/* {errors.email && touched.email && <div className="invalid-feedback">{errors.email}</div>} */}
                  </label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={4} lg={5} xl={4} xxl={3}>
                <div className="mb-3">
                  <PhoneInput
                    className="form-control form-control-lg PhoneInputs"
                    international
                    countryCallingCodeEditable={false}
                    defaultCountry="IN"
                    name="contCode"
                    value={formData.contCode}
                    onChange={handlePhoneChange}
                    onBlur={() =>
                      setTouched((prev) => ({ ...prev, contCode: true }))
                    }
                  />
                </div>
              </Col>
              <Col xs={8} lg={7} xl={8} xxl={9}>
                <div className="mb-3">
                  <label htmlFor="Mobile" className="input-material">
                    <input
                      type="text"
                      name="mobileNo"
                      className={`form-control form-control-lg ${
                        errors.mobileNo && touched.mobileNo
                          ? "is-invalid"
                          : touched.mobileNo
                          ? "is-valid"
                          : ""
                      }`}
                      value={formData.mobileNo}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder=""
                    />
                    <span className="label-material">
                      Mobile<span className="text-danger">*</span>
                    </span>
                    {/* {errors.mobileNo && touched.mobileNo && <div className="invalid-feedback">{errors.mobileNo}</div>} */}
                  </label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="mb-3">
                  <label htmlFor="Company Name" className="input-material">
                    <input
                      type="text"
                      name="company"
                      className={`form-control form-control-lg ${
                        errors.company && touched.company
                          ? "is-invalid"
                          : touched.company
                          ? "is-valid"
                          : ""
                      }`}
                      value={formData.company}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder=""
                    />
                    <span className="label-material">
                      Company Name<span className="text-danger">*</span>
                    </span>
                    {/* {errors.company && touched.company && <div className="invalid-feedback">{errors.company}</div>} */}
                  </label>
                </div>
              </Col>
              <Col lg={12}>
                <div className="mb-3">
                  <label
                    htmlFor="Number of Employee"
                    className="input-material"
                  >
                    <select
                      aria-label=""
                      name="noEmployee"
                      className={`form-select form-select-lg ${
                        errors.noEmployee && touched.noEmployee
                          ? "is-invalid"
                          : touched.noEmployee
                          ? "is-valid"
                          : ""
                      }`}
                      value={formData.noEmployee}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Number of Employees</option>
                      <option value="1-50">1-50</option>
                      <option value="51-100">51-100</option>
                      <option value="101-200">101-200</option>
                      <option value="201-500">201-500</option>
                      <option value="501-1000">501-1000</option>
                      <option value="1000+">1000+</option>

                      {/* <option value="">Number of Employees</option>
                      <option value="1-50">1-50</option>
                      <option value="51-100">51-100</option>
                      <option value="101-200">101-200</option>
                      <option value="201-500">201-500</option> */}

                    </select>
                    {/* <span className="label-material">Number of Employees<span className="text-danger">*</span></span> */}
                    {/* {errors.noEmployee && touched.noEmployee && <div className="invalid-feedback">{errors.noEmployee}</div>} */}
                  </label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="mb-3">
                  <label htmlFor="Message" className="input-material">
                    <textarea
                      name="myText"
                      className="form-control form-control-lg"
                      value={formData.myText}
                      onChange={handleInputChange}
                      placeholder=""
                    ></textarea>
                    <span className="label-material">Message</span>
                  </label>
                </div>
              </Col>
            </Row>
            <div className="d-flex justify-content-between mb-3">
              <Button variant="light" onClick={handleModalClose}>Close</Button>
              <Button variant="pink" type="submit">Submit Now</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalForm;
